import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {BarCodeScannerContext} from "../../../../../../../contexts/barCodeScannerContext";
import {Grid} from "@mui/material";
import MobileItem from "../../../../../../../components/WMS/Mobile/MobileItem";
import {FormattedMessage} from "react-intl";
import RightDrawer from "../../../../../../../components/WMS/Mobile/RightDrawer";
import {blueColor} from "../../../../../../../assets/jss/main";
import Badge from "../../../../../../../components/Badge";
import {ShippingMethodsDiscr} from "../../../../../../../utils/ShippingMethods";
import MondialRelayIcon from "assets/img/carrier-icons/mondial_relay.svg";
import ClickAndCollectIcon from "assets/img/carrier-icons/click_and_collect.svg";
import CustomButton from "../../../../../../../components/CustomButton";
import ShipmentModal from "./component/ShipmentModal";
import TipperManualSelectionDrawer from "./component/TipperManualSelectionDrawer";
import {getWMSContainerWithCodeBar} from "../../../../../../../api/wms/wmsContainers/wmsContainers";
import {assignShipmentToContainer} from "../../../../../../../api/wms/shipment/shipment";
import {shipmentSorted} from "../../../../../../../api/wms/shipment/shipment";
import {WmsContainerType} from "../../../../../../../utils/WMSContainerType";
import Toast from "../../../../../../../components/WMS/Toast";
import ErrorIcon from "../../../../../../../assets/img/error.svg";
import {KNCarrierType} from "../../../../../../../utils/KuehneNagelCarrierType";
import {WMSContext} from "../../../../../context/WMSContext";
import FullTransfer from "../../../../../../../components/WMS/FullTransfer";

ContainerDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    inSorting: PropTypes.bool.isRequired,
    setInSorting: PropTypes.func.isRequired,
    container: PropTypes.object.isRequired,
    resetList: PropTypes.bool.isRequired,
    setResetList: PropTypes.func.isRequired,
    scannedShipment: PropTypes.object
};

function ContainerDrawer({open, handleClose, inSorting, setInSorting, container, beginSorting, resetList, setResetList, scannedShipment = null}) {
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentInventory, currentOrganization} = useContext(WMSContext)

    const [openShipmentModal, setOpenShipmentModal] = useState(false)
    const [currentShipment, setCurrentShipment] = useState()
    const [openTipperManualSelectionDrawer, setOpenTipperManualSelectionDrawer] = useState(false)
    const [isCC, setIsCC] = useState(false)
    const [ccError, setCcError] = useState(false)
    const [isCcInternalWMSShip, setIsCcInternalWMSShip] = useState(false)
    const [massTransfer, setMassTransfer] = useState(false)
    const [containerShipment, setContainerShipment] = useState()

    const getShippingMethodIcon = (discr) => {
        switch (discr) {
            case ShippingMethodsDiscr.MONDIAL_RELAY:
                return MondialRelayIcon
            case ShippingMethodsDiscr.CLICK_COLLECT:
                return ClickAndCollectIcon
        }
    }

    const handleCloseShipmentModal = () => {
        setOpenShipmentModal(false)
    }

    const handleManualSelection = () => {
        setOpenTipperManualSelectionDrawer(true)
    }

    const handleCloseManualSelectionDrawer = () => {
        setOpenTipperManualSelectionDrawer(false)
    }

    const handleSelectedTipper = (selectedTipperBarcode) => {
        getWMSContainerWithCodeBar(selectedTipperBarcode).then(r => {
            if (isCC && !isCcInternalWMSShip && r.type !== WmsContainerType.CC) {
                setCcError(true)
            } else {
                assignShipmentToContainer(selectedTipperBarcode, currentShipment.id).then(() => {
                    shipmentSorted(currentShipment.id).then(() => {
                        setOpenTipperManualSelectionDrawer(false)
                        setOpenShipmentModal(false)
                        setResetList(!resetList)
                    })
                }).catch(err => {
                    setResetList(!resetList)
                })
            }
        })
    }

    const handleShipmentSelect = (selectedShipment) => {
        if (inSorting) {
            setCurrentShipment(selectedShipment)
            setOpenShipmentModal(true)
        }
    }

    useEffect(() => {
        if (scannedString && scannedString.length > 0) {
            setEnableScan(false)

            if (scannedString === container.codebar) {
                setInSorting(true)
                resetScannedString()
                setEnableScan()
                return
            }
            const scannedShipment = container.shipments.find((shipment) => shipment.shipmentBarcode === scannedString)

            if (scannedShipment) {
                setCurrentShipment(scannedShipment)
                setOpenShipmentModal(true)
                resetScannedString()
            } else {
                setEnableScan(true)
            }
        }
    }, [scannedString]);

    useEffect(() => {
        setEnableScan(true)
        if(currentShipment && (currentShipment.shippingMethodDiscr === ShippingMethodsDiscr.CLICK_COLLECT || (currentShipment.shippingMethodShopName === KNCarrierType.NAVETTE))) {
            setIsCC(true)
        }
    }, [currentShipment]);

    useEffect(() => {
        if (currentInventory && currentShipment && currentShipment.ccPointCode) {
            setIsCcInternalWMSShip(currentInventory.code !== currentShipment.ccPointCode)
        }
    }, [currentInventory, currentShipment]);

    useEffect(() => {
        if (scannedShipment) {
            setCurrentShipment(scannedShipment)
        }
        resetScannedString()
    }, []);

    useEffect(() => {
        if (currentOrganization) {
            setMassTransfer(currentOrganization.massTransfer)
        }
        if (0 < container?.shipments.length) {
            let shipmentsId = []
            container.shipments.forEach((shipment) => {
                shipmentsId.push(shipment.id)
            })

            setContainerShipment(shipmentsId)
        }
    }, [container, currentOrganization]);

    return (
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerLeftContent={<span style={{marginLeft: "8px"}}>{container.name}</span>}
            headerRightContent={<Badge rounded isBold={false}>{container.shipmentCount} <FormattedMessage id={"wms.triShipping.shipmentCount"}/></Badge>}
            footer={
                <Grid container flexWrap={"nowrap"}>
                    {!inSorting && (
                        <CustomButton onClick={() => beginSorting(container)} fullWidth>
                            <FormattedMessage id={"wms.triShipping.button.beginSorting"}/> {container.name}
                        </CustomButton>
                    )}

                    {massTransfer && (
                        <FullTransfer
                            handleIsValid={() => setResetList(!resetList)}
                            currentContainer={container}
                            inSorting={inSorting}
                            shipments={containerShipment}
                            toContainers={[
                                WmsContainerType.CC,
                                WmsContainerType.TIPPER,
                                WmsContainerType.TROLLEY
                            ]}
                        />
                    )}
                </Grid>
            }
        >
            {ccError && (
                <Toast
                    open={ccError}
                    handleClose={() => setCcError(false)}
                    title={<FormattedMessage id={"wms.triShipping.ccErrorToast.title"}/>}
                    subtitle={<FormattedMessage id={"wms.triShipping.ccErrorToast.subtitle"}/>}
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                />
            )}
            {openShipmentModal && currentShipment && (
                <ShipmentModal
                    open={openShipmentModal}
                    handleClose={handleCloseShipmentModal}
                    shipment={currentShipment}
                    sortShipment={handleSelectedTipper}
                    manualSelection={handleManualSelection}
                />
            )}

            {openTipperManualSelectionDrawer && currentShipment && (
                <TipperManualSelectionDrawer
                    open={openTipperManualSelectionDrawer}
                    handleClose={handleCloseManualSelectionDrawer}
                    handleSelectedTipper={handleSelectedTipper}
                    currentShipment={currentShipment}
                    isCC={isCC}
                    isCcInternalWMSShip={isCcInternalWMSShip}
                />
            )}

            <Grid container>
                {container && container.shipments.map((shipment) => {
                    return (
                            <div style={{width: "100%"}} onClick={() => handleShipmentSelect(shipment)}>
                                <MobileItem>
                                    <MobileItem.LeftSide
                                        title={
                                        <>
                                            <FormattedMessage id={"wms.triShipping.orderNumberLabel"}/>
                                            <span style={{color: blueColor}}>
                                                {/*Here, orderNumber is orderDisplayExternalId*/}
                                                #{currentOrganization?.showDisplayExternalId && shipment.orderNumber ? shipment.orderNumber : shipment.orderExternalId}
                                            </span>
                                        </>
                                    }
                                        subtitle={
                                        <>
                                            <FormattedMessage id={"wms.triShipping.trackingNumber"}/>
                                            <span style={{color: blueColor}}>
                                                #{shipment.trackingNumber}
                                            </span>
                                        </>
                                    }
                                    />
                                    <MobileItem.RightSide>
                                        <Badge color={"info"} isBold={false} rounded size={"large"}>
                                        <span style={{display: "flex", alignItems: "center", gap: "4px"}}>
                                            <img src={getShippingMethodIcon(shipment.shippingMethodIcon)} alt={shipment.shippingMethod}/> {shipment.shippingMethod}
                                        </span>
                                        </Badge>
                                    </MobileItem.RightSide>
                                </MobileItem>
                            </div>
                    )
                })}
            </Grid>
        </RightDrawer>
    );
}

export default ContainerDrawer;
